import { render, staticRenderFns } from "./vehicle-box-small.vue?vue&type=template&id=804f6ce2&scoped=true&lang=pug&"
import script from "./vehicle-box-small.vue?vue&type=script&lang=js&"
export * from "./vehicle-box-small.vue?vue&type=script&lang=js&"
import style0 from "./vehicle-box-small.vue?vue&type=style&index=0&id=804f6ce2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804f6ce2",
  null
  
)

export default component.exports